<div class="announcement">
  <div class="message-box">
    <div [innerHTML]="message() | safeHtml: SAFE_HTML_OPTIONS" class="message"></div>
    <ng-content></ng-content>
  </div>
</div>
